// React for Website
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
//outsource
import { Row, Col, message, Button, Form, Divider, Space } from "antd";

//components
import StaffAvatar from "./component/staff_avatar";
import StaffStatus from "./component/staff_status";
import StaffIRD from "./component/staff_IRD";
import StaffUserName from "./component/staff_user_name";
import StaffPreferredName from "./component/staff_preferred_name";
import StaffFirstName from "./component/staff_first_name";
import StaffLastName from "./component/staff_last_name";
import StaffPhone from "./component/staff_phone";
import StaffEmail from "./component/staff_email";
import StaffAddress from "./component/staff_address";
import StaffAdressSuburb from "./component/staff_address_suburb";
import StaffAdressCity from "./component/staff_address_city";
import StaffAdressState from "./component/staff_address_state";
import StaffAdressPostCode from "./component/staff_address_post_code";

//redux
import { useDispatch, useSelector } from "react-redux";
import {
  getInfoDetailByUserId,
  getStaffDetailByUserId,
  updateStaffInfo,
  unSnapStaffInfo,
} from "../../../store/staff/staff.action";
import {
  detailSelector,
  infoDetailSelector,
} from "../../../store/staff/staff.selector";
import StaffRoster from "./component/staff_shop_roster";
import StaffLevel from "./component/staff_level";

const StaffDetail = () => {
  // -------------------------- VAR --------------------------
  const params = useParams();
  const id = params?.id || "";
  const userId = params?.userId || "";
  const navigate = useNavigate();
  const [form] = Form.useForm();

  // -------------------------- STATE --------------------------
  const [avatar, setAvatar] = useState("");
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const detail = useSelector(detailSelector);
  const infoDetail = useSelector(infoDetailSelector);
  // console.log(detail);

  // console.log("currentUser", currentUser);
  // -------------------------- FUNCTION --------------------------
  const onFinish = (values) => {
    const { active, ...user } = values;
    const update = {
      ...user,
      avatar,
    };

    // console.log("update", update);

    setLoading(true);
    if (detail && currentUser) {
      dispatch(
        updateStaffInfo({ update, active, detail, currentUser }, (response) => {
          setLoading(false);
          if (response.status === 500) {
            message.error(response.data || "Error, Please try again!");
          } else {
            message.success("The user's info was update!");
            setEdit(false);
          }
        })
      );
    }
  };

  const onFinishFailed = (errors) => {
    console.log("errors", errors);
  };

  const onSelect = (value) => {
    setAvatar(value);
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (id !== "" && userId !== "") {
      dispatch(getInfoDetailByUserId({ userId }));
      dispatch(getStaffDetailByUserId({ userId, branch: id }));
    }

    return () => dispatch(unSnapStaffInfo());
  }, [dispatch]);

  //pack data
  useEffect(() => {
    if (detail && infoDetail) {
      const avatar = infoDetail?.avatar || "";

      const data = {
        ...infoDetail,
        active: detail?.active || false,
        level: infoDetail?.level || "Trainee",
        shopRoster: infoDetail?.shopRoster || false,
        individualRoster: infoDetail?.individualRoster || false,
      };

      setAvatar(avatar);
      setCurrentUser(data);
      form.setFieldsValue(data);
    }
  }, [detail, infoDetail]);

  // -------------------------- RENDER --------------------------
  const renderTitle = () => {
    return (
      <Row>
        <Col lg={12} md={12} sm={24} xs={24}>
          <b style={{ fontSize: 18 }}>Edit Staff</b>
        </Col>
        <Col align="right" lg={12} md={12} sm={24} xs={24}>
          {renderButtonGroup()}
        </Col>
      </Row>
    );
  };

  const renderButtonGroup = () => {
    if (edit) {
      return (
        <Row justify="end" gutter={[10, 10]}>
          {/* <Col>
            <Button
              onClick={() => navigate(`/branchs/detail/${id}/staff`)}
              loading={loading}
              style={{ width: 120 }}
              type="default"
            >
              Cancel
            </Button>
          </Col> */}
          <Col>
            <Button
              form="detail-staff-form"
              htmlType="submit"
              style={{ width: 120, backgroundColor: "green", border: 0 }}
              type="primary"
              loading={loading}
              // disabled={disabled}
            >
              Save
            </Button>
          </Col>
        </Row>
      );
    }

    return (
      <Row justify="end" gutter={[10, 10]}>
        <Col>
          <Button
            onClick={() => navigate(`/branchs/detail/${id}/staff`)}
            loading={loading}
            style={{ width: 120 }}
            type="default"
          >
            Back
          </Button>
        </Col>
        <Col>
          <Button
            onClick={() => setEdit(true)}
            style={{ width: 120 }}
            type="primary"
            loading={loading}
            // disabled={disabled}
          >
            Edit
          </Button>
        </Col>
      </Row>
    );
  };

  const renderStaffDetails = () => {
    return (
      <Row gutter={[20, 20]}>
        <Col lg={8} md={8} sm={24} xs={24}>
          <h1>Staff Details</h1>
          <p>Basic information about your staff</p>
        </Col>
        <Col lg={16} md={16} sm={24} xs={24}>
          {renderFormDetail()}
        </Col>
      </Row>
    );
  };

  const renderStatus = () => {
    return (
      <Row>
        <Col lg={24} md={24} sm={24} xs={24} style={{ padding: 0 }}>
          <StaffStatus disabled={!edit} />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24} style={{ padding: 0 }}>
          <StaffRoster disabled={!edit} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24} style={{ padding: 0 }}>
          <StaffIRD disabled={!edit} />
        </Col>
        <Col lg={6} md={6} sm={24} xs={24} />
        <Col lg={6} md={6} sm={24} xs={24} style={{ padding: 0 }} align="right">
          <StaffLevel disabled={!edit} />
        </Col>
      </Row>
    );
  };

  const renderFormDetail = () => {
    return (
      <Row gutter={[20, 20]}>
        <Col align="left" lg={12} md={12} sm={24} xs={24}>
          <StaffAvatar onSelect={onSelect} avatar={avatar} disabled={!edit} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          {renderStatus()}
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <StaffUserName disabled={!edit} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <StaffPreferredName disabled={!edit} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <StaffFirstName disabled={!edit} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <StaffLastName disabled={!edit} />
        </Col>
        {/*phone va email can duoc xac thuc khi thay doi, nen chi nen thao tac tu phia staff*/}
        {/* <Col lg={12} md={12} sm={24} xs={24}>
          <StaffPhone disabled={!edit} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <StaffEmail disabled={!edit} />
        </Col> */}
        <Col lg={24} md={24} sm={24} xs={24}>
          <StaffAddress form={form} disabled={!edit} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <StaffAdressSuburb disabled={!edit} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <StaffAdressCity disabled={!edit} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <StaffAdressState disabled={!edit} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <StaffAdressPostCode disabled={!edit} />
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row id="staff-detail">
      <Col lg={24} md={24} sm={24} xs={24}>
        {renderTitle()}
      </Col>
      <Divider />
      <Col lg={24} md={24} sm={24} xs={24}>
        <Form
          id="detail-staff-form"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
          type="basic"
          layout="vertical"
          autoComplete="off"
        >
          {renderStaffDetails()}
        </Form>
      </Col>
    </Row>
  );
};

export default StaffDetail;
